import {
  DistributePaymentForTreaty,
  DistributePaymentForTreatyVariables,
} from "_graphql/queries/__generated__/DistributePaymentForTreaty";
import { useMatch, useNavigate, useSearch } from "react-location";

import DistributePaymentForm from "components/forms/distribute-payment";
import { LocationGenerics } from "router/location";
import { Modal } from "components";
import { TreatyType } from "_graphql/__generated__/globalTypes";
import { distributeTreatyPayment } from "_graphql/visal/queries/treaties";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useNonProportionalPayment } from "hooks/data/use-treaties";
import { wrapClick } from "utils";

export default function DistributePaymentContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const { params } = useMatch<LocationGenerics>();
  const searchParams = useSearch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();
  const [distribute, { loading }] = useMutation<
    DistributePaymentForTreaty,
    DistributePaymentForTreatyVariables
  >(distributeTreatyPayment, {
    refetchQueries: ["GetNonProportionalTreatyPayments"],
  });
  const form = useFormik<any>({
    initialValues: {
      deductions: [],
    },
    onSubmit: async (variables) => {
      await distribute({
        variables: {
          type: TreatyType.NONPROPORTIONAL,
          treatyPaymentId: searchParams.id || "",
          paymentInformation: variables.deductions.map((d: any) => ({
            offer_participant_payment_id: d.offer_participant_id,
            paid_details: JSON.stringify({
              payment_type: d.payment_type,
              payment_from: {
                cheque_number: d.cheque_number ? d.cheque_number : "N/A",
                bank_name: d.bank_name,
              },
              payment_to: d.b_bank_name ? d.b_bank_name : "N/A",
            }),
            payment_comment: d.comment,
          })),
          treatyId: params.treaty || "",
        },
      })
        .then((data) => {
          if (data.data?.distributePaymentForTreaty) {
            toast.success("Payment distributed successfully");
            setOpen(false);
            navigate({
              search(prev) {
                return {
                  ...prev,
                };
              },
            });
          } else {
            toast.error("Failed to distribute payment");
          }
        })
        .catch((e) => {});
    },
    onReset: () => {
      setOpen(false);
    },
  });
  const { loading: fetching } = useNonProportionalPayment({
    treatyNpPaymentId: searchParams.id || "",
  });

  return (
    <Modal
      open={open}
      setOpen={() => {
        setOpen(false);
        navigate({
          search(prev) {
            return {
              ...prev,
            };
          },
        });
      }}
      size="5xl"
      title="Dsitribute Payment"
      loading={fetching}
      description="Distribute payment to the offer participants."
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Distributing payment..." : "Distribute Payment"}
          </button>
        </>
      )}
    >
      <DistributePaymentForm form={form} deductions={[]} />
    </Modal>
  );
}
